import urls from "../utils/urls"
import { post} from '../utils/http'
const state= {
    
    result:{},
  
    code:0,
    page:1,
    olddata:[]
   
    
}

const mutations={
   
    
    
    
    getPaymentData(state,val){
        

     
        post(urls.admin.order_payment.index,val).then((result)=>{
          
          
          
          state.result=result
          
       
       
        
       
           
        });
        
    },
   
   
   
}
const  actions={
    getPaymentDataAction(context,value){
        
        context.commit("getPaymentData",value)
       
    },
    
   
   
    
   
  
    
  
    
   

}

export default {state,mutations,actions}